import { render, staticRenderFns } from "./TicketTemplate.vue?vue&type=template&id=a03d6fb6&"
import script from "./TicketTemplate.vue?vue&type=script&lang=js&"
export * from "./TicketTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports